var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.6,
    height: 17.281,
    viewBox: "0 0 21.6 17.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye-slash",
    "data-name": "Icon awesome-eye-slash",
    d: "M10.8,13.5A4.842,4.842,0,0,1,5.977,9.008L2.437,6.271A11.249,11.249,0,0,0,1.2,8.148a1.092,1.092,0,0,0,0,.985,10.825,10.825,0,0,0,9.6,5.987,10.484,10.484,0,0,0,2.629-.353l-1.751-1.355a4.865,4.865,0,0,1-.878.088Zm10.592,1.961-3.731-2.884A11.18,11.18,0,0,0,20.4,9.132a1.092,1.092,0,0,0,0-.985A10.825,10.825,0,0,0,10.8,2.16,10.4,10.4,0,0,0,5.828,3.432L1.534.114A.54.54,0,0,0,.776.208l-.663.853a.54.54,0,0,0,.095.758L20.066,17.166a.54.54,0,0,0,.758-.095l.663-.853a.54.54,0,0,0-.1-.758Zm-6.2-4.793L13.865,9.643A3.2,3.2,0,0,0,9.946,5.528a1.608,1.608,0,0,1,.314.952,1.574,1.574,0,0,1-.052.338L7.724,4.9A4.8,4.8,0,0,1,10.8,3.78a4.857,4.857,0,0,1,4.86,4.86,4.745,4.745,0,0,1-.469,2.029Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDisable);
export default __webpack_public_path__ + "static/media/eye-disable.094e71e4515fa49f1b3073b29313d675.svg";
export { ForwardRef as ReactComponent };